const TEMP_CONFIG_CHANGE = 'TEMP_CONFIG/CHANGE';

export default function tempConfigurationChangeAction (data: { [key: string]: any }) {
  return {
    type: TEMP_CONFIG_CHANGE,
    payload: {
        data: data
     }
  };
}

export { TEMP_CONFIG_CHANGE };